import React, { useState } from 'react'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import Grid from '@mui/material/Grid'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import DataTable, { ColumnSettingType, RenderColumnAction } from '../control/dataTable/DataTable'
import EditAction from '../control/dataTable/renderAction/EditAction'
import DeleteAction from '../control/dataTable/renderAction/DeleteAction'
import axios from 'axios'

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(4),
    },
}))

type ParamServerSideType = {
    pageNumber: number
    rowPerPage: number
    sortField: string
    sortType: string
}

const DataTablePlayground = () => {
    const classes = useStyles()
    const [data, setData] = useState<any[]>([])
    const [totalItem, setTotalItem] = useState<number>(0)
    const [paramServerSide, setParamServerSide] = useState<ParamServerSideType>({
        pageNumber: 1,
        rowPerPage: 5,
        sortField: "id",
        sortType: "asc"
    })

    const columnOptions: ColumnSettingType[] = [
        {
            dataKey: 'id',
            label: 'ID',
            align: 'center',
            width: 100,
        },
        {
            dataKey: 'name',
            label: 'Name',
            align: 'left',
        },
        {
            dataKey: 'departmentName',
            label: 'Department',
            align: 'left',
            width: 300,
        },
        {
            dataKey: 'groupName',
            label: 'Group',
            align: 'left',
            width: 300,
        },
        {
            dataKey: 'action',
            label: 'Action',
            align: 'center',
            type: 'action',
            render: (row: any) => (
                <RenderColumnAction>
                    <EditAction data={row} variant="contained" onClick={(data: any) => console.log(data)} />
                    <DeleteAction data={row} onClick={(data: any) => console.log(data)} />
                </RenderColumnAction>
            ),
        },
    ]

    const onSort = (sortField: string, sortType: string) => {
        const params: ParamServerSideType = {
            pageNumber: paramServerSide.pageNumber,
            rowPerPage: paramServerSide.rowPerPage,
            sortField: sortField,
            sortType: sortType
        }
        // console.log('onSort params', params)
        callService(params)
        setParamServerSide(params)
    }

    const onChangePageNumber = (page: number) => {
        const params: ParamServerSideType = {
            pageNumber: page,
            rowPerPage: paramServerSide.rowPerPage,
            sortField: paramServerSide.sortField,
            sortType: paramServerSide.sortType
        }
        callService(params)
        setParamServerSide(params)
    }

    React.useEffect(() => {
        callService(paramServerSide)
    }, [])

    const callService = async (params: ParamServerSideType) => {
        try {
            const url = `http://localhost:7000/api/users/mockdata/?pageNumber=${params.pageNumber}&rowPerPage=${params.rowPerPage}&sortField=${params.sortField}&sortType=${params.sortType}`
            const result = await axios.get(url)
            setData(result.data.data)
            setTotalItem(result.data.total)
            return { result }
        } catch (error) {
            return { error }
        }
    }

    return (
        <div className={classes.root}>
            <Grid container>
                <Grid item xs={12}>
                    <Typography variant="h3" gutterBottom>
                        Control: Data Table
                    </Typography>
                    <Divider />
                </Grid>
                <Grid item xs={12} style={{ minWidth: '600px' }}>
                    <DataTable<any>
                        columnOptions={columnOptions}
                        dataSource={data}
                        maxHeight={200}
                        onRowClick={(e) => console.log(e)}
                        onPageNumber={onChangePageNumber}
                        onRowPerPage={() => console.log('onRowPerPage')}
                        totalItem={totalItem}
                        rowsPerPage={paramServerSide.rowPerPage}
                        onSort={onSort}
                        sortField={paramServerSide.sortField}
                        sortType={paramServerSide.sortType}
                    />
                </Grid>
            </Grid>
        </div>
    )
}

export default DataTablePlayground
